<template>
  <div>
    <aron-table
      :endPoint="route"
      :filterEndpoint="filterEndpoint"
      :key="route"
      :formType="formType"
      :viewOnly="viewOnly"
      :showAddBtn="showAddBtn"
      :showActionButton="showActionButton"
    ></aron-table>
  </div>
</template>

<script>
import aronTable from "../../components/aron/table/tblmain.vue";
export default {
  components: {
    aronTable
  },
  data() {
    return { 
      route: this.$route.params.endPoint,
      formType: "sidebarRightSide",
      viewOnly: true,
      showAddBtn: false,
      showActionButton: false,
    };
  }, 
  watch: {
    $route(to, from) {
      this.route = to.params.endPoint;
      this.formType = "sidebarRightSide";
    }
  },
  methods: {
    name() {}
  },
  computed: {
    filterEndpoint() {
      return "search_" + this.route;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>